import { Injectable } from '@angular/core';
import { RouterStateSnapshot, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService, deleteCookie } from './auth.service';
import { getCookie, setCookie } from 'src/app/services/caching.service';

@Injectable()
export class AuthGuardService {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.isAuthenticated()) {
      // Save the attempted URL for redirecting after login
      if (!getCookie('redirectURL')) {
        setCookie('redirectURL', state.url.toString());
      }

      // Redirect to login page
      void this.router.navigate(['/login']);
      return false;
    } else {
      console.log('AuthGuardService - User authenticated');
      console.log(this.authService.getIdentityClaims());

      this.authService.isAuthenticatedSubject$.next(true);

      // Check if there's a redirect URL from before login
      let url = getCookie('redirectURL');
      if (url) {
        void this.router.navigateByUrl(url);
        deleteCookie('redirectURL');
      }

      return true;
    }
  }

  /**
   * Get redirect cookie
   * IMS Only issue
   */
  public GetRedirectCookie(): string {
    return getCookie('redirectURL');
  }
}
